/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import _ from 'lodash';
import {
  system,
  reminderSetupTitle,
  taskTypeList,
  defaultTaskTypeValue,
} from './ConstantData';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import CollectionLetters from './CollectionLetters';
import CheckLog from './CheckLog';
import SuspendedCheck from './SuspendedCheck';
import MailedDate from './MailedDate';
import {
  setTaskType,
  getSysReminderSetup,
  dispatchInputValue,
  dispatchCheckLogErrorMsg,
  dispatchCheckSuspErrorMsg,
  dispatchCollectErrorMsg,
  dispatchMailedDateErrorMsg,
  sysReminderSetupList,
  postSaveOrUpdate,
  dispatchDeleteReminder,
  dispatchSaveOrUpdate,
} from '../store/actions';
import {
  handleScrollToEvent,
  isNumeric,
  closeTab,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

const ReminderSetup = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [curIndex, setCurIndex] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [disableSaveCancel, setDisableSaveCancel] = React.useState(false);
  const [addReminderBtn, setAddReminderBtn] = React.useState(false);
  const [successMessages, setSuccessMessage] = React.useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const taskType = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.taskType
  );
  const reminder_list = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.reminder_list
  );
  const getInputValue = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.getInputValue;
  });
  const getCheckLogErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgCheckLog;
  });
  const getCheckSuspErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgCheckSusp;
  });
  const getCollectErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgCollect;
  });
  const getMailedDateErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgMailedDate;
  });
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const saveOrUpdateMessage = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.saveOrUpdateMessage;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getDeleteReminder = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.getDeleteReminder;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges?.length > 0) {
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
      );
    }
  }, [kcRoles]);
  // dispatch get reminder setup data and default task type
  React.useEffect(() => {
    if (taskType) {
      const reminderPaylod = {
        taskType: taskType,
      };
      dispatch(getSysReminderSetup(reminderPaylod));
      dispatch(dispatchDeleteReminder([]));
    } else {
      dispatch(setTaskType(defaultTaskTypeValue));
    }
  }, [taskType]);
  // get reminder list data and dispatch pagination value
  React.useEffect(() => {
    if (reminder_list) {
      setSuccessMessage([]);
      dispatch(dispatchInputValue(1));
    }
  }, [reminder_list]);
  // succuess message for save reminder list
  React.useEffect(() => {
    if (saveOrUpdateMessage && saveOrUpdateMessage.message === 'SUCCESS') {
      setSuccessMessage([constantMessageData.SUCCESSMESSAGE_GENERIC]);
      setAddReminderBtn(false);
      setDisableSaveCancel(false);
      dispatch(dispatchDeleteReminder([]));
      dispatch(dispatchSaveOrUpdate([]));
    } else if (saveOrUpdateMessage === 'closeTab') {
      dispatch(dispatchSaveOrUpdate([]));
      dispatch(getSysReminderSetup([]));
      dispatch(dispatchDeleteReminder([]));
      setSuccessMessage([]);
      dispatch(setTaskType(undefined));
      dispatch(dispatchInputValue(1));
      setAddReminderBtn(false);
      setDisableSaveCancel(false);
      closeTab('/reminderSetup', history, dispatch);
    }
  }, [saveOrUpdateMessage]);
  // get InputValue from Redux and assign to state
  React.useEffect(() => {
    setSuccessMessage([]);
    const inputValue = isNumeric(getInputValue);
    if (inputValue && getInputValue) {
      setCurIndex(parseInt(getInputValue));
    } else {
      setCurIndex(getInputValue);
    }
  }, [getInputValue]);
  // default page top scroll event
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // on click functinality of pagination text field
  const onClickPaginationArrow = (diffValue) => {
    let indexValueAssign;
    let preValueInputValue;
    const inputValueNum = isNumeric(getInputValue);
    if (diffValue === 'Next') {
      if (inputValueNum) {
        indexValueAssign = parseInt(getInputValue) + 1;
        preValueInputValue = parseInt(getInputValue);
      } else {
        indexValueAssign = getInputValue + 1;
        preValueInputValue = getInputValue;
      }
    } else if (inputValueNum) {
      indexValueAssign = parseInt(getInputValue) - 1;
      preValueInputValue = parseInt(getInputValue);
    } else {
      indexValueAssign = getInputValue - 1;
      preValueInputValue = getInputValue;
    }
    setCurIndex(indexValueAssign);
    dispatch(dispatchInputValue(indexValueAssign));
  };
  // on change functionality for paginate text field
  const paginateOnChange = (curentIndex) => {
    setCurIndex(curentIndex);
  };
  const paginateReminderSetupData = (curentIndex) => {
    dispatch(dispatchInputValue(curentIndex));
  };
  const addReminder = async () => {
    setAddReminderBtn(true);
    setDisableSaveCancel(true);
    await dispatch(sysReminderSetupList([]));
    if (taskType === 'CHECKDATE' || taskType === 'SUSPNDDATE') {
      const addReminderPayload = [...reminder_list];
      const newReminderPayload = {
        reminderSeqNum: null,
        addEditRow: true,
        reminderTypeCd: taskType,
        reminderName: '',
        rebateProgramCd: null,
        templateId: 0,
        paymentStatusTypeCd: null,
        paidPct: 0,
        owedAmt: 0,
        daysSinceInvDistributed: 0,
        usePriorQtrUraIfZeroInd: 0,
        daysSinceInvPrinted: '',
        checkPayeeCd: 'MD',
        respUserId: null,
        lastUpdateDt: null,
        lastUpdateUserId: logInUser,
        corrLinkId: null,
        addedDt: null,
        addedUserId: logInUser,
        rpcShortDescr: null,
        cvShortDescr: null,
        reminderShortDescr: null,
      };
      addReminderPayload.unshift(newReminderPayload);
      /* istanbul ignore next */
      //setTimeout(() => {
      dispatch(sysReminderSetupList(addReminderPayload));
      //}, 100);
    } else if (taskType === 'MAILDATE') {
      const addReminderPayload = [...reminder_list];
      const newReminderPayload = {
        reminderSeqNum: null,
        addEditRow: true,
        reminderTypeCd: taskType,
        reminderName: '',
        rebateProgramCd: '',
        templateId: null,
        paymentStatusTypeCd: null,
        paidPct: null,
        owedAmt: null,
        daysSinceInvDistributed: null,
        usePriorQtrUraIfZeroInd: null,
        daysSinceInvPrinted: '',
        checkPayeeCd: null,
        respUserId: null,
        lastUpdateDt: null,
        lastUpdateUserId: logInUser,
        corrLinkId: null,
        addedDt: null,
        addedUserId: logInUser,
        rpcShortDescr: null,
        cvShortDescr: null,
        reminderShortDescr: null,
      };
      addReminderPayload.unshift(newReminderPayload);
      /* istanbul ignore next */
      //setTimeout(() => {
      dispatch(sysReminderSetupList(addReminderPayload));
      //}, 100);
    } else if (taskType === 'COLLECT') {
      const addReminderPayload = [...reminder_list];
      const newReminderPayload = {
        reminderSeqNum: null,
        addEditRow: true,
        reminderTypeCd: taskType,
        reminderName: '',
        rebateProgramCd: '',
        templateId: '-1',
        paymentStatusTypeCd: '1',
        paidPct: '',
        owedAmt: '',
        daysSinceInvDistributed: '',
        usePriorQtrUraIfZeroInd: 0,
        daysSinceInvPrinted: null,
        checkPayeeCd: null,
        respUserId: null,
        lastUpdateDt: null,
        lastUpdateUserId: logInUser,
        corrLinkId: null,
        addedDt: null,
        addedUserId: logInUser,
        rpcShortDescr: null,
        cvShortDescr: null,
        reminderShortDescr: null,
      };
      addReminderPayload.unshift(newReminderPayload);
      /* istanbul ignore next */
      //setTimeout(() => {
      dispatch(sysReminderSetupList(addReminderPayload));
      //}, 100);
    }
  };
  const deleteReminder = async () => {
    // dispatch(sysReminderSetupList([]));
    let addReminderPayload = [...reminder_list];
    const getDeleteObj = reminder_list[curIndex - 1];
    addReminderPayload = addReminderPayload.filter(
      (item) => item.reminderSeqNum !== getDeleteObj.reminderSeqNum
    );
    const deleteReminderArr = getDeleteReminder || [];
    deleteReminderArr.push(getDeleteObj);
    await dispatch(dispatchDeleteReminder(deleteReminderArr));
    setDisableSaveCancel(true);
    /* istanbul ignore next */
    //setTimeout(() => {
    dispatch(sysReminderSetupList(addReminderPayload));
    //}, 100);
  };
  const validateRequest = () => {
    const checkValidation = reminder_list[curIndex - 1];
    let localErr = [];
    if (taskType === 'CHECKDATE') {
      localErr = getCheckLogErrorMsg || [];
      if (checkValidation.daysSinceInvPrinted) {
        const rx = /^[0-9]{0,3}?$/;
        if (checkNumberValidation(rx, checkValidation.daysSinceInvPrinted)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
          localErr.push({
            field: 'daysSinceInvPrinted',
            errorType: 'daysSinceInvReq',
            message: `Item ${checkValidation.daysSinceInvPrinted} does not pass the validation test.`,
          });
        }
      } else if (!checkValidation.daysSinceInvPrinted) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
        localErr.push({
          field: 'daysSinceInvPrinted',
          errorType: 'daysSinceInvReq',
          message:
            'Item Days since Check Updated did not pass the validation test.',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
      }
      const unique = [...new Set(localErr)];
      dispatch(dispatchCheckLogErrorMsg(unique));
      if (unique.length != 0) {
        return false;
      }
      return true;
    }
    if (taskType === 'SUSPNDDATE') {
      if (checkValidation.daysSinceInvPrinted) {
        const rx = /^[0-9]{0,3}?$/;
        if (checkNumberValidation(rx, checkValidation.daysSinceInvPrinted)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
          localErr.push({
            field: 'daysSinceInvPrinted',
            errorType: 'daysSinceInvReq',
            message: `Item ${checkValidation.daysSinceInvPrinted} does not pass the validation test.`,
          });
        }
      } else if (!checkValidation.daysSinceInvPrinted) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
        localErr.push({
          field: 'daysSinceInvPrinted',
          errorType: 'daysSinceInvReq',
          message:
            'Item Days since Check Suspension did not pass the validation test.',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
      }
      const unique = [...new Set(localErr)];
      dispatch(dispatchCheckSuspErrorMsg(unique));
      if (unique.length != 0) {
        return false;
      }
      return true;
    }
    if (taskType === 'MAILDATE') {
      if (checkValidation.daysSinceInvPrinted) {
        const rx = /^[0-9]{0,3}?$/;
        if (checkNumberValidation(rx, checkValidation.daysSinceInvPrinted)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvPrinted'
          );
          localErr.push({
            field: 'daysSinceInvPrinted',
            errorType: 'daysSinceInvReq',
            message: `Item ${checkValidation.daysSinceInvPrinted} does not pass the validation test.`,
          });
        }
      } else if (!checkValidation.daysSinceInvPrinted) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
        localErr.push({
          field: 'daysSinceInvPrinted',
          errorType: 'daysSinceInvReq',
          message:
            'Item Days since Invoice Printed did not pass the validation test.',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvPrinted'
        );
      }
      const unique = [...new Set(localErr)];
      dispatch(dispatchMailedDateErrorMsg(unique));
      if (unique.length != 0) {
        return false;
      }
      return true;
    }
    if (taskType === 'COLLECT') {
      if (checkValidation.daysSinceInvDistributed) {
        const rx = /^[0-9]{0,3}?$/;
        if (
          checkNumberValidation(rx, checkValidation.daysSinceInvDistributed)
        ) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvDistributed'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvDistributed'
          );
          localErr.push({
            field: 'daysSinceInvDistributed',
            errorType: 'daysSinceInvReq',
            message: `Item ${checkValidation.daysSinceInvDistributed} does not pass the validation test.`,
          });
        }
      } else if (!checkValidation.daysSinceInvDistributed) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvDistributed'
        );
        localErr.push({
          field: 'daysSinceInvDistributed',
          errorType: 'daysSinceInvReq',
          message: 'Days since Invoice Distributed cannot be blank/ invalid',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvDistributed'
        );
      }
      if (!checkValidation.templateId || checkValidation.templateId === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'templateId');
        localErr.push({
          field: 'templateId',
          errorType: 'templateIdReq',
          message: 'Template Name is Required.',
        });
      } else {
        localErr = localErr?.filter((item) => item.field !== 'templateId');
      }
      const unique = [...new Set(localErr)];
      dispatch(dispatchCollectErrorMsg(unique));
      if (unique.length != 0) {
        return false;
      }
      return true;
    }
  };
  // check number validation
  const checkNumberValidation = (rx, amountVal) => {
    let val = false;
    if (rx.test(amountVal?.toString()?.replace('-', '').trim())) {
      val = true;
    }
    return val;
  };
  // handing save API calling
  const masterDataSave = (saveType) => {
    setOpen(false);
    const tempObj = {
      delReminderVO: getDeleteReminder?.length > 0 ? getDeleteReminder : [],
      addReminderVO: reminder_list
        ?.filter((x) => x.addEditRow)
        ?.map((item) => {
          delete item.lastUpdateDt;
          delete item.addEditRow;

          return item;
        }),
    };
    dispatch(postSaveOrUpdate(tempObj, saveType));
    handleScrollToEvent();
  };
  // click on cancel after call
  const handleSaveClose = () => {
    setOpen(false);
  };
  // call after check all validation
  const onSubmit = () => {
    if (reminder_list?.length != 0) {
      if (validateRequest()) {
        setOpen(true);
      }
    } else {
      setOpen(true);
    }
  };
  // handing reset All fields & data
  const resetAllFields = () => {
    setOpenCancel(false);
    setDisableSaveCancel(false);
    const reminderPaylod = {
      taskType: taskType,
    };
    dispatch(getSysReminderSetup(reminderPaylod));
    dispatch(dispatchDeleteReminder([]));
    dispatch(dispatchCheckLogErrorMsg([]));
    dispatch(dispatchCheckSuspErrorMsg([]));
    dispatch(dispatchMailedDateErrorMsg([]));
    dispatch(dispatchCollectErrorMsg([]));
    setAddReminderBtn(false);
  };
  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      REMINDER_SEQ_NUM: reminder_list && reminder_list[0].reminderSeqNum,
    });
  };
  // for disable save cancel update
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (reminder_list && Object.keys(reminder_list).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (
            item.navTo === '/reminderSetup' &&
            disableSaveCancel &&
            !isEnablebyRole
          ) {
            item.isFormDirty = true;
          } else if (item.navTo === '/reminderSetup') item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disableSaveCancel || reminder_list, isEnablebyRole]);

  // handle close and confirm popup
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/reminderSetup' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/reminderSetup' && item.isFormSave) {
          item.isFormSave = false;
          masterDataSave(true);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const radioGroupRef = React.useRef(null);

  useEffect(() => {
    // After the component renders, make sure the first enabled radio button gets focused
    if (radioGroupRef.current) {
      const firstEnabledRadioButton = radioGroupRef.current.querySelector(
        'input[type="radio"]:not([disabled])'
      );
      if (firstEnabledRadioButton) {
        firstEnabledRadioButton.focus(); // Focus the first enabled radio button
      }
    }
  }, [taskTypeList]); // Re-run the effect when the taskTypeList changes

  return (
    <div className="tBillPanel custom-check" data-testid="reminder-component">
      <div className="tabs-container">
        <SaveCancelPopup
          open={open}
          data-testid="savePopup"
          title="Save"
          onConfim={() => {
            masterDataSave(false);
          }}
          onCancel={() => {
            handleSaveClose();
          }}
        />
        <SaveCancelPopup
          open={openCancel}
          data-testid="cancelPopup"
          title="Cancel"
          onConfim={() => {
            resetAllFields();
          }}
          onCancel={() => {
            setOpenCancel(false);
          }}
        />
        <SaveCancelPopup
          open={openConfirmDelete}
          data-testid="deletePopup"
          title="Delete"
          moduleName="the Reminder"
          onConfim={() => {
            setOpenConfirmDelete(false);
            deleteReminder();
          }}
          onCancel={() => {
            setOpenConfirmDelete(false);
          }}
        />
        <Spinner load={spinnerLoader} />
        <CustomSeparator parent1={system} parent2={reminderSetupTitle} />
        <Box className="alone-pagination ">
          <Box>
            <Button
              title="Previous"
              className="btns rotate-left"
              data-testid="uc-paginate-arrow-left"
              disabled={
                !(getInputValue > 1) ||
                !isNumeric(getInputValue) ||
                getInputValue > reminder_list?.length
              }
              onClick={() => {
                onClickPaginationArrow('Prev');
              }}
            >
              <SVGComponent iconName="Icon-arrow" />
              <span className="hide-elm" aria-hidden="true">
                Previous
              </span>
            </Button>
          </Box>
          <Box>
            <label className="m-0" htmlFor="paginate-count">
              <TextField
                id="paginate-count"
                data-testid="uc-input-paginate"
                variant="outlined"
                className="searchInput input-count"
                value={reminder_list?.length > 0 ? curIndex : ''}
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  paginateOnChange(e.target.value);
                }}
                onBlur={(e) => {
                  paginateReminderSetupData(e.target.value);
                }}
              />
            </label>
          </Box>
          <Box className="btns"> of {reminder_list?.length}</Box>
          <Box>
            <Button
              title="Next"
              className="btns rotate-right ml-0"
              data-testid="uc-paginate-arrow-right"
              disabled={
                !(getInputValue < reminder_list?.length) ||
                !isNumeric(getInputValue)
              }
              onClick={() => {
                onClickPaginationArrow('Next');
              }}
            >
              <SVGComponent iconName="Icon-arrow" />
              <span className="hide-elm">Next</span>
            </Button>
          </Box>
        </Box>
        <DisplaySuccessMessages successMessages={successMessages} />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getCheckLogErrorMsg?.length > 0
                ? _.map(getCheckLogErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getCheckSuspErrorMsg?.length > 0
                ? _.map(getCheckSuspErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getCollectErrorMsg?.length > 0
                ? _.map(getCollectErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getMailedDateErrorMsg?.length > 0
                ? _.map(getMailedDateErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
        <div className="row mb-2">
          <div className="col-12 pl-0">
            <div className="btn-wrapper float-right mt-4 mb-4">
              <Button
                className="btn btn-success btn-save"
                data-testid="onSubmit"
                onClick={() => {
                  onSubmit();
                }}
                disabled={!disableSaveCancel}
              >
                <SVGComponent iconName="Icon-awesome-save" />
                Save
              </Button>
              <Button
                className="btn btn-cancel"
                data-testid="open_Cancel"
                onClick={() => {
                  setOpenCancel(true);
                }}
                disabled={!disableSaveCancel || isEnablebyRole}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
            <div className="btn-wrapper mt-3 mb-3">
              <div className="float-right mt-3 mb-3 hide-on-print">
                <div className="d-flex align-items-center justify-content-end th-icon-group">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="history-tooltip">View History</Tooltip>
                    }
                  >
                    <div
                      className="th-icon ic-history"
                      role="button"
                      data-testid="view-history"
                      onClick={() => handleViewHistory()}
                      tabIndex="0"
                      onKeyPress={() => handleViewHistory()}
                    >
                      {' '}
                      <span className="ic-title"> History </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            <div className="clearfix" />
          </div>
          <div className="col-12 mb-2">
            <fieldset className="custom-fieldset h-100">
              <legend className="same-font-family">
                Task Type<span className="mandatory">*</span>
              </legend>
              <div className="sub-radio no-margin ">
                <FormControl>
                  <RadioGroup
                    row
                    name="acc-plan-row-radio-buttons-group"
                    defaultValue={taskType || defaultTaskTypeValue}
                    value={taskType || defaultTaskTypeValue}
                    ref={radioGroupRef}
                  >
                    {taskTypeList && !_.isEmpty(taskTypeList)
                      ? taskTypeList.map((v, i) => (
                          <FormControlLabel
                            value={v.value}
                            control={
                              <Radio
                                onChange={(e) => {
                                  dispatch(setTaskType(v.value));
                                  dispatch(dispatchCheckLogErrorMsg([]));
                                  dispatch(dispatchCheckSuspErrorMsg([]));
                                  dispatch(dispatchCollectErrorMsg([]));
                                  dispatch(dispatchMailedDateErrorMsg([]));
                                  setAddReminderBtn(false);
                                }}
                                ref={radioGroupRef}
                                tabIndex={
                                  v.value === 'electRPFiletobeSent' ||
                                  v.value === 'electRPCheck' ||
                                  v.value === 'electRPSuspend'
                                    ? -1
                                    : 0
                                }
                              />
                            }
                            ref={radioGroupRef}
                            label={v.name}
                            key={v.value && _.kebabCase(v.value)}
                            data-testid="radio-box-change-control"
                            disabled={
                              v.value === 'electRPFiletobeSent' ||
                              v.value === 'electRPCheck' ||
                              v.value === 'electRPSuspend'
                            }
                            // tabIndex={
                            //   v.value === 'electRPFiletobeSent' ||
                            //   v.value === 'electRPCheck' ||
                            //   v.value === 'electRPSuspend' ? -1 : 0
                            // }
                          />
                        ))
                      : null}
                  </RadioGroup>
                </FormControl>
              </div>
            </fieldset>
          </div>
        </div>
        <div>
          {taskType === 'COLLECT' && reminder_list ? (
            <CollectionLetters setDisableSaveCancel={setDisableSaveCancel} />
          ) : null}
          {taskType === 'CHECKDATE' && reminder_list ? (
            <CheckLog setDisableSaveCancel={setDisableSaveCancel} />
          ) : null}
          {taskType === 'SUSPNDDATE' && reminder_list ? (
            <SuspendedCheck setDisableSaveCancel={setDisableSaveCancel} />
          ) : null}
          {taskType === 'MAILDATE' && reminder_list ? (
            <MailedDate setDisableSaveCancel={setDisableSaveCancel} />
          ) : null}
        </div>
        <div className="row mb-2">
          <div className="col-12 pl-0">
            <div className="btn-wrapper float-right mt-4 mb-4">
              <Button
                className="btn btn-success btn-save"
                data-testid="add_reminder"
                onClick={() => {
                  addReminder();
                }}
                disabled={
                  getCheckLogErrorMsg?.length > 0 ||
                  getCheckSuspErrorMsg?.length > 0 ||
                  getCollectErrorMsg?.length > 0 ||
                  getMailedDateErrorMsg?.length > 0 ||
                  addReminderBtn ||
                  isEnablebyRole
                }
              >
                <SVGComponent iconName="Icon-addCircle" />
                Add Reminder
              </Button>
              <Button
                className="btn btn-cancel"
                data-testid="delete_reminder"
                onClick={() => {
                  setOpenConfirmDelete(true);
                }}
                disabled={isEnablebyRole}
              >
                <SVGComponent iconName="Icon-delete" />
                Delete Reminder
              </Button>
            </div>
          </div>
        </div>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="REMINDER"
          keyValue={keyValue}
          isSpinner={false}
        />
      )}
    </div>
  );
};
export default ReminderSetup;
